module.exports = new __parcel__URL__("ThumbnailNavigation.7523958e.svg").toString();